module.exports = __webpack_public_path__ + "static/island-house-logo-becdb1bccacf4968cabe447c6bb6716a.svg";